require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./los-cinco-mejores-futbolistas-de-la-uefa-champions-league.json") })
        }
      }, "path---los-cinco-mejores-futbolistas-de-la-uefa-champions-league");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---los-cinco-mejores-futbolistas-de-la-uefa-champions-league!./.cache/json/los-cinco-mejores-futbolistas-de-la-uefa-champions-league.json
// module id = 452
// module chunks = 231608221292675